<app-animated-background class="absolute top-0 h-vh w-dvw"></app-animated-background>
<div class="min-h-screen absolute top-0 w-full flex items-center justify-center p-4 z-[999]">
  <div class="w-full max-w-md login-card">
    @if(!verifyOTP) {
    <div class="header-section flex px-8 pt-8 pb-4">
      <div class="lock-icon sm:text-left">
        <mat-icon>lock</mat-icon>
      </div>
      <div class="text-center w-full">
        <h1 class="welcome-title">Welcome</h1>
        <p class="welcome-subtitle">Lets sign you up!</p>
      </div>
    </div>

    <form [formGroup]="registerForm" (ngSubmit)="onSubmit()" class="form-section space-y-2 p-8">
      <div class="form-group">
        <mat-form-field appearance="outline" class="w-full enhanced-field">
          <mat-label>Business Name</mat-label>
          <input matInput formControlName="business_name" type="email" placeholder="Enter your email address">
          <mat-icon matPrefix class="field-icon">email</mat-icon>
          <mat-error *ngIf="registerForm.get('email')?.hasError('required')">
            <mat-icon class="error-icon">error</mat-icon>
            Name is required
          </mat-error>
          <mat-error *ngIf="registerForm.get('email')?.hasError('email')">
            <mat-icon class="error-icon">error</mat-icon>
            Please enter a valid name
          </mat-error>
        </mat-form-field>
      </div>

      <div class="form-group">
        <mat-form-field appearance="outline" class="w-full enhanced-field">
          <mat-label>Business Email</mat-label>
          <input matInput formControlName="email" type="email" placeholder="Enter business email">
          <mat-icon matPrefix class="field-icon">email</mat-icon>
          <mat-error *ngIf="registerForm.get('email')?.hasError('required')">
            <mat-icon class="error-icon">error</mat-icon>
            Email is required
          </mat-error>
          <mat-error *ngIf="registerForm.get('email')?.hasError('email')">
            <mat-icon class="error-icon">error</mat-icon>
            Please enter a valid email
          </mat-error>
        </mat-form-field>
      </div>

      <div class="flex items-center justify-between">
        <p class="upload-label">Business Logo</p>
        <label class="upload-zone cursor-pointer" for="business-icon-upload">
          <input id="business-icon-upload" type="file" accept="image/png,image/jpeg,image/jpg,image/webp,image/svg+xml"
            class="hidden" (change)="onBusinessIconSelected($event)">

          @if(businessIconPreview) {
          <div class="preview-wrapper">
            <img [src]="businessIconPreview" alt="Business icon preview" class="preview-image">
            <button type="button" mat-icon-button class="remove-preview"
              (click)="removeBusinessIcon(); $event.preventDefault();">
              <mat-icon>close</mat-icon>
            </button>
          </div>
          <p class="upload-hint">Click to replace icon</p>
          } @else {
          <div class="flex items-center gap-2">
          <mat-icon class="upload-icon">cloud_upload</mat-icon>
          <p class="upload-hint">Click to upload business icon</p>
          </div>
          <!-- <p class="upload-subhint">PNG, JPG, JPEG, WEBP, SVG</p> -->
          }
        </label>
      </div>

      <div class="form-group">
        <mat-form-field appearance="outline" class="w-full enhanced-field">
          <mat-label>Password</mat-label>
          <input matInput [type]="hidePassword ? 'password' : 'text'" formControlName="password"
            placeholder="Enter your password">
          <mat-icon matPrefix class="field-icon">lock</mat-icon>
          <button mat-icon-button matSuffix (click)="hidePassword = !hidePassword" type="button" class="toggle-btn">
            <mat-icon>{{hidePassword ? 'visibility_off' : 'visibility'}}</mat-icon>
          </button>
          <mat-error *ngIf="registerForm.get('password')?.hasError('required')">
            <mat-icon class="error-icon">error</mat-icon>
            Password is required
          </mat-error>
        </mat-form-field>
      </div>

      <div class="form-group">
        <mat-form-field appearance="outline" class="w-full enhanced-field">
          <mat-label>Confirm Password</mat-label>
          <input matInput [type]="hideConfirmPassword ? 'password' : 'text'" formControlName="confirm_password"
            placeholder="Enter your password">
          <mat-icon matPrefix class="field-icon">lock</mat-icon>
          <button mat-icon-button matSuffix (click)="hideConfirmPassword = !hideConfirmPassword" type="button"
            class="toggle-btn">
            <mat-icon>{{hideConfirmPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
          </button>
          <mat-error
            *ngIf="registerForm.value.password && (registerForm.value.confirm_password == registerForm.value.password)">
            <mat-icon class="error-icon">error</mat-icon>
            Confirm password is required
          </mat-error>
        </mat-form-field>
      </div>

      <button class="submit-button w-full" [disabled]="loading">
        <span class="button-content">
          @if (loading) {
          <mat-spinner diameter="20"></mat-spinner>
          <span>Creating Account...</span>
          } @else {
          <span>Create Account</span>
          }
        </span>
      </button>

      <div class="forgot-password flex items-center justify-center w-full gap-1 text-center">
        <p>Already have an account?</p>
        <a routerLink="/login" class="forgot-link">Login</a>
      </div>
    </form>
    } @else {
    <div class="header-section px-8 pt-8">
      <div class="lock-icon">
        <mat-icon>lock</mat-icon>
      </div>
      <div class="text-center">
        <h1 class="welcome-title">Verify OTP</h1>
        <p class="welcome-subtitle">Please check your email</p>
      </div>
    </div>

    <form [formGroup]="OTPForm" (ngSubmit)="onVerify()" class="form-section space-y-2 p-8">
      <div class="form-group">
        <mat-form-field appearance="outline" class="w-full enhanced-field">
          <mat-label>OTP</mat-label>
          <input matInput formControlName="otp" [maxLength]="6" pattern="[0-9]{6}"
            placeholder="Enter verification code">
          <mat-icon matPrefix class="field-icon">password</mat-icon>
          <mat-error *ngIf="registerForm.get('otp')?.hasError('required')">
            <mat-icon class="error-icon">error</mat-icon>
            OTP is required
          </mat-error>
          <mat-error *ngIf="registerForm.get('otp')?.hasError('otp')">
            <mat-icon class="error-icon">error</mat-icon>
            Invalid OTP
          </mat-error>
        </mat-form-field>
      </div>

      <button class="submit-button w-full" [disabled]="loading">
        <span class="button-content">
          @if (loading) {
          <mat-spinner diameter="20"></mat-spinner>
          <span>Verifing...</span>
          } @else {
          <span>Verify</span>
          }
        </span>
      </button>

      <div class="forgot-password flex items-center justify-center w-full gap-1 text-center">
        <p class="{{showTimer? '':'text-blue-400 cursor-pointer'}}" (click)="resendOTP()">Resend OTP</p>
        @if(showTimer) {
        in
        <countdown #cd [config]="{ leftTime: 60, format: 'm:s' }" (event)="handleCountdown($event)" />
        }
      </div>
    </form>
    }
  </div>
</div>